import request from '@/utils/request'

//专业园地删除
export function plotTreeRemove(data) {
	return request({
		url: '/majorPlot/majorGardenPlotDO/treeRemove',
		method: 'get',
		params: data
	})
}
//专业园地tree列表
export function plotTree(data) {
	return request({
		url: '/majorPlot/majorGardenPlotDO/tree',
		method: 'get',
		params: data
	})
}
//添加专业园地
export function plotTreeAdd(data) {
	return request({
		url: '/majorPlot/majorGardenPlotDO/treeAdd',
		method: 'post',
		data
	})
}
//修改专业园地
export function plotTreeUpdate(data) {
	return request({
		url: '/majorPlot/majorGardenPlotDO/treeUpdate',
		method: 'post',
		data
	})
}
//专业园地内容
export function plotContext(data) {
	return request({
		url: '/majorPlot/majorGardenPlotContextDO/contextPage',
		method: 'get',
		params: data
	})
}
//删除专业园地内容
export function plotContextDelete(data) {
	return request({
		url: '/majorPlot/majorGardenPlotContextDO/contextDelete',
		method: 'get',
		params: data
	})
}
//添加专业园地内容
export function plotContextAdd(data) {
	return request({
		url: '/majorPlot/majorGardenPlotContextDO/contextAdd',
		method: 'post',
		data
	})
}
//发布/撤回 专业园地内容
export function plotContextRelease(data) {
	return request({
		url: '/majorPlot/majorGardenPlotContextDO/contexteRelease',
		method: 'get',
		params: data
	})
}
//修改专业园地内容
export function plotContextUpdate(data) {
	return request({
		url: '/majorPlot/majorGardenPlotContextDO/contextUpdate',
		method: 'post',
		data
	})
}
//专业园地内容查看详情
export function plotContextDetail(data) {
	return request({
		url: '/majorPlot/majorGardenPlotContextDO/contextDetail',
		method: 'get',
		params: data
	})
}
